import styled from "@emotion/styled";
export const StyleButtonWrapper = styled.div<any>`
  display: flex;
  justify-content: ${(props: any) => props.justify};
`;
export const StyleButton = styled.button<any>`
  border-radius: ${(props) => props.radius || 8}px;
  border: 0px;
  width: ${(props) => (props?.width ? `${props?.width}%` : "auto")};
  height: ${(props) => (props?.height ? props?.height : 35)}px;
  background: ${(props) =>
    props.variant === "reset"
      ? props.theme.orange.orange100
      : props.theme.colors[props.bg || "primary"]};
  padding: 22px 34px;
  font-size: 14px;
  color: ${(props) =>
    props.variant === "reset"
      ? props.theme.orange.orange700
      : props.theme.colors[props?.tc || "white"]};
  ${(props) => props.styleButton};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  transition: all 300ms ease-in;
  &:hover {
    scale: 1.01;
  }
  &:active {
    scale: 0.96;
  }
  pointer-events: ${(props: any) => props.disabled && "none"};
  background-color: ${(props: any) => props.disabled && "gray"};
`;
